import type Question from './Question'

export default class QuestionDescription implements Question {
  componentName = 'QuestionDescription'
  description: string

  constructor(data: Partial<QuestionDescription> = {}) {
    this.description = data?.description ?? ''
  }

  isEmpty() {
    return !this.description
  }

  reset() {
    this.description = ''
  }
}
